<template>
    <g fill-rule="evenodd">
        <g>
            <g>
                <path d="M17.333 0C21.015 0 24 2.985 24 6.667v10.666C24 21.015 21.015 24 17.333 24H6.667C2.985 24 0 21.015 0 17.333V6.667C0 2.985 2.985 0 6.667 0h10.666zm0 2.267H6.667c-2.347 0-4.264 1.836-4.393 4.15l-.007.25v10.666c0 2.347 1.836 4.264 4.15 4.393l.25.007h10.666c2.347 0 4.264-1.836 4.393-4.15l.007-.25V6.667c0-2.347-1.836-4.264-4.15-4.393l-.25-.007zm-7.959 4.54V16.5H7.592V9.925H5.365V8.737c1.323-.04 2.403-.566 2.619-1.93h1.39zm8.073-.027v6.129h1.485v1.336h-1.485V16.5H15.72v-2.255h-4.576v-1.579l4.684-5.886h1.62zm-1.66 1.93h-.027s-.5.797-.891 1.296l-1.377 1.742c-.392.473-1.08 1.202-1.08 1.202v.027s.357-.028.755-.048l.269-.012c.133-.005.264-.008.38-.008h1.903v-2.754c0-.54.068-1.444.068-1.444z" transform="translate(-781 -470) translate(781 470)"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'ios14Icon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 24 24');
    }
};
</script>
